import useUserPermission from "~/hooks/useUserPermission";

export const useDatasetAssistant = (): boolean => {
  return useUserPermission("use:ai-agents");
};

export default useDatasetAssistant;
